import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Rating from "@material-ui/lab/Rating";
import { Box, Button, Typography } from "@material-ui/core";
import { sendAdyaUserFeedback } from "../../../../services/indianbank_services/adya_feedback_services";
import { connect } from "react-redux";
import { clearSessionStorageData } from "../../../../services/other_services";
import StarIcon from '@material-ui/icons/Star'; // Import Material UI star icon

const useStyles = makeStyles({
  label: {
    fontSize: "3.5rem",
  },
  rootButton: {
    borderRadius: "18px",
    padding: "5px 25px 5px 25px",
    backgroundColor: (props) => (props.disabled ? "rgba(12, 77, 162, 0.5)" : "rgba(12, 77, 162, 1)"),
    color: "#fff",
    "&:hover": {
      backgroundColor: (props) => (props.disabled ? "rgba(12, 77, 162, 0.5)" : "rgba(12, 77, 162, 1)"),
    },
  },
  star: {
    fontSize: "4rem", // Set the star size to 4rem
  },
});

function AdyaRatingSubmit(props) {
  const [value, setValue] = React.useState(0);
  const [isRated, setIsRated] = React.useState(false);
  const classes = useStyles({ disabled: value === 0 });

  function onSubmitConfirm() {
    props.toggleConfirmModal(false);
    clearSessionStorageData();
    var botMessage = "CLOSECHAT";
    window.parent.postMessage(botMessage, "*");
    window.location.reload(false);
  }

  return (
    <>
      <Box>
        <Typography component="subtitle1" style={{ fontFamily: "Poppins", fontWeight: "600", fontSize: "22px" }}>
          Give your Feedback
        </Typography>
        <Typography variant="subtitle2" style={{ color: "rgba(12, 77, 162, 1)", fontFamily: "Poppins", fontWeight: "700", fontSize: "16px" }}>
          How would you rate your overall experience?
        </Typography>
      </Box>
      <Box component="fieldset" mb={3} borderColor="transparent">
        <Rating
          name="simple-controlled"
          value={value}
          onChange={(event, newValue) => {
            setValue(newValue);
          }}
          disabled={isRated}
          icon={<StarIcon className={classes.star} />} // Use custom star icon with size 4rem
          emptyIcon={<StarIcon className={classes.star} style={{ opacity: 0.55 }} />} // Use custom empty star icon
        />
      </Box>
      <Box mb={3}>
        <Button
          variant="outlined"
          size="small"
          color="primary"
          className={classes.rootButton}
          disabled={value === 0}
          style={{ marginBottom : "24px", marginLeft : "33%"}}
          onClick={() => {
            sendAdyaUserFeedback({
              sessionId: props.sessionDetails.session_id,
              adyaRating: value,
              adya_rating_timestamp: `${new Date().toLocaleString("en-GB", { hour12: true })}`,
            })
              .then((res) => {
                if (res) {
                  setIsRated(true);
                  onSubmitConfirm();
                }
              })
              .catch((err) => {
                setIsRated(true);
                onSubmitConfirm();
              });
          }}
        >
          Submit
        </Button>
      </Box>
    </>
  );
}

const mapDispatchToProps = (dispatch) => {
  return {
    toggleConfirmModal: (status) => {
      dispatch({ type: "UPDATE_COMFIRM_MODAL", payload: status });
    },
    resetLoginStatus: () => {
      dispatch({ type: "LOGOUT_ACTION", payload: "" });
    },
  };
};

const mapStateToProps = (state) => {
  return {
    logInData: state.logInStatus,
    sessionDetails: state.sessionDetails,
    confirmModal: state.confirmModal,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AdyaRatingSubmit);
